import IconButton from "@mui/material/IconButton";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import {format, getISOWeek, getISOWeekYear, startOfISOWeek} from "date-fns";
import React from "react";
import addDays from "date-fns/addDays";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

export default function SelectWeek({dateRange, onChange, showWeekPicker = false, responsive = false}) {
  const year = new Date().getFullYear();
  const firstMonday = startOfISOWeek(new Date(year, 0, 4));
  const weekCount = getISOWeek(new Date(year, 11, 28));
  const weeks = Array.from({length: weekCount}, (_, index) => ({
    number: index + 1,
    start: addDays(firstMonday, index * 7)
  }));

  const changeStartDate = (e, prev = false) => {
    const weekStart = addDays(dateRange.weekStart, prev ? -7 : 7);
    onChange({weekStart, weekEnd: addDays(weekStart, 6)});
  };

  return (
    <React.Fragment>
      {showWeekPicker && <FormControl size="small" style={{minWidth: responsive ? 0 : 240, marginRight: 8,
        ...(responsive ? {flex: 1} : {})}}>
        <InputLabel id="rota-select-week-label">Select Week</InputLabel>
        <Select
          labelId="rota-select-week-label"
          id="rota-select-week"
          label="Select Week"
          value={getISOWeekYear(dateRange.weekStart) === year ? getISOWeek(dateRange.weekStart) : ''}
          onChange={event => {
            const weekStart = weeks[event.target.value - 1].start;
            onChange({weekStart, weekEnd: addDays(weekStart, 6)});
          }}
        >
          {weeks.map(({number, start}) => <MenuItem value={number} key={number}>
            <span style={{fontWeight: 'bold', padding: '0 2px'}}>Wk {number}</span>
            <span style={{padding: '0 5px'}}>|</span>
            <span style={{color: '#666'}}>{format(start, 'do MMM')} - {format(addDays(start, 6), 'do MMM')}</span>
          </MenuItem>)}
        </Select>
      </FormControl>}
      <IconButton
        color="primary"
        aria-label="Go to the previous week"
        onClick={(e) => changeStartDate(e, true)}
        size="large">
      <NavigateBeforeIcon/>
      </IconButton>
      {!showWeekPicker && <span>{dateRange.weekStart ? format(dateRange.weekStart, 'do LLL') : null} - {dateRange.weekEnd ? format(dateRange.weekEnd, 'do LLL') : null}</span>}
      <IconButton
        color="primary"
        aria-label="Go to the next week"
        onClick={changeStartDate}
        size="large">
      <NavigateNextIcon/>
      </IconButton>

    </React.Fragment>
  );
}
